import React from "react";
import { connect } from "react-redux";
import { loadSubMenu } from "../actions";

import MainSensibilizacionPlanMovilidad from "./main";
import FinalizarSensibilizacionPlanMovilidad from "./finalizar";

class SensibilizacionPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadSubMenu();
  }

loadSubMenu = () => {
  const tabs = [
    { text: "Main", contentId: 0 },
    { text: "Finalizar", contentId: 1 },

  ];
  this.props.dispatch(loadSubMenu(tabs, tabs.length ? tabs[0].contentId : null));
}

renderBody = () => {
  switch (this.props.subMenuPosition) {
    case 0: {
      return (<MainSensibilizacionPlanMovilidad />);
    }
    case 1: {
      return (<FinalizarSensibilizacionPlanMovilidad />);
    }
    default:
      return <div />;
  }
}

render() {
  return (
    <React.Fragment>
      {this.renderBody()}
    </React.Fragment>
  );
}
}

const mapStateToProps = (state) => ({
  subMenuPosition: state.planMovilidad.subMenuPosition,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SensibilizacionPlanMovilidad);
